// parallax.js

/**
 *
 * @param element
 * @param options
 * @returns {any}
 *
 * const layer_1 = document.querySelector('.my_element');
 * createParallax(layer_1, {speed: -50, axis: 'y', maxTranslate: 250, bidirectional: false, startAtBreakpoint: 1024});
 */
export default function createParallax(element, options) {

    const parallaxInstance = {
        init: () => {
            window.addEventListener('scroll', parallaxInstance.updateParallax);
            parallaxInstance.element = element;
            parallaxInstance.settings = Object.assign({
                speed: -25,
                axis: 'y',
                translateXstart: 0,
                maxTranslate: 0,
                translateOffset: 0,
                bidirectional: false,
                startAtBreakpoint: 0,
            }, options);

            return parallaxInstance;
        },

        updateParallax: () => {
            if (!parallaxInstance.element) return;

            const settings = parallaxInstance.settings;
            if (settings.startAtBreakpoint > 0 && window.innerWidth < settings.startAtBreakpoint) {
                return;
            }

            const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            let scrolled = ((scrollTop - parallaxInstance.getOffsetTopRelativeToBody(parallaxInstance.element)) * settings.speed) / 100;

            if (settings.translateOffset > 0) {
                scrolled += settings.translateOffset;
            }

            parallaxInstance.element.classList.remove('parallax--max');
            if (settings.maxTranslate > 0) {
                if (scrolled > settings.maxTranslate) {
                    scrolled = settings.maxTranslate;
                    parallaxInstance.element.classList.add('parallax--max');
                } else if (scrolled < -settings.maxTranslate) {
                    scrolled = -settings.maxTranslate;
                    parallaxInstance.element.classList.add('parallax--max');
                }
            }

            if (settings.translateXstart) {
                scrolled += parseInt(settings.translateXstart);
            }

            if (!settings.bidirectional && settings.speed * scrolled < 0) {
                return;
            }

            const translate = {
                'x': settings.axis === 'x' ? `${scrolled}px` : '0',
                'y': settings.axis === 'y' ? `${scrolled}px` : '0'
            };

            parallaxInstance.element.style.transform = `translate(${translate.x}, ${translate.y})`;
        },

        getOffsetTopRelativeToBody(element) {
            let offsetTop = 0;
            while (element.offsetParent) {
                offsetTop += element.offsetTop;
                element = element.offsetParent;
            }
            return offsetTop;
        }
    };

    const scrollHandler = () => {
        let ticking = false;
        return () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    parallaxInstance.updateParallax();
                    ticking = false;
                });
                ticking = true;
            }
        };
    };

    window.addEventListener('scroll', scrollHandler());

    return parallaxInstance.init();
}